export default __webpack_public_path__ + "static/media/logoColor.5e2d6ea4.png";